import React from 'react';

const FORM_INVALID_STATE = 1;

class BenutzerdatenBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.props;
    // Scope der Componente muss zu Verfügung stehen ... muss für jede Methode gemacht werden!
    this.handleVornameChange = this.handleVornameChange.bind(this); 
    this.handleNachnameChange = this.handleNachnameChange.bind(this);
    this.handleEMailChange = this.handleEMailChange.bind(this);
    this.handleInstagramnameChange = this.handleInstagramnameChange.bind(this);
  }
  // Handler des Farbe
  handleVornameChange(event) {
    this.setState({ vorname: event.target.value });
    this.props.onVornameChange(event.target.value);
  }
  handleNachnameChange(event) {
    this.setState({ nachname: event.target.value });
    this.props.onNachnameChange(event.target.value);
  }
  handleEMailChange(event) {
    this.setState({ email: event.target.value });
    this.props.onEMailChange(event.target.value);
  }
  handleInstagramnameChange(event) {
    this.setState({ instagramname: event.target.value });
    this.props.onInstagramnameChange(event.target.value);
  }
  render() {
    let vornameValid =  ((this.props.vornameIsValid === FORM_INVALID_STATE) ? 'invalid' : 'valid');
    let nachnameValid =  ((this.props.nachnameIsValid === FORM_INVALID_STATE) ? 'invalid' : 'valid');
    let emailValid =  ((this.props.emailIsValid === FORM_INVALID_STATE) ? 'invalid' : 'valid');
    
    return (
    
          <div className="Component Benutzerdaten">
            
            <h3 className="nobile">Zuerst brauchen wir ein paar kleine Infos von dir</h3>
            <section className="flex2 auseinander">
              <div className="formelement two breaking">
                <label className={vornameValid}>
                  Vorname
                  <span className="field-message">Bitte Vornamen eingeben</span>
                </label>
                <input type="text" name='vorname'  value={this.state.vorname} onChange={this.handleVornameChange} />
              </div>
              
              <div className="formelement two breaking">
                <label className={nachnameValid}>
                Nachname
                <span className="field-message">Bitte Nachnamen eingeben</span>
                </label>
                <input type="text" name='nachname' value={this.state.nachname} onChange={this.handleNachnameChange} />
              </div>
              

              <div className="formelement two breaking">
                <label className={emailValid}>
                E-Mail Adresse
                <span className="field-message">Bitte E-Mail Adresse eingeben</span>
                </label>
                <input type="text" name='email' value={this.state.email} onChange={this.handleEMailChange} />
              </div>
              
              <div className="formelement two breaking">
                <label className={emailValid}>
                Instagram-Name
                </label>
                <input type="text" name='instagram'  value={this.state.instagramname} onChange={this.handleInstagramnameChange} />
              </div>
              
            </section>
          </div>
         
    );
  }
}
export default BenutzerdatenBlock;


// WEBPACK FOOTER //
// ./src/BenutzerdatenBlock.js